/* eslint-disable no-console, import/prefer-default-export */
import { isStepOnPage } from '../utils/configuration-utils';

const updateFrameColorUI = () => {
  if (!isStepOnPage('frameColor')) return;
  const selectedOption = document.querySelector('[name="frameColor"]:checked');
  const img = document.querySelector('.frame-color-image img');
  if (selectedOption && img) {
    img.src = selectedOption.getAttribute('data-option-img');
  }
};

export {
  updateFrameColorUI,
};
/* eslint-enable no-console, import/prefer-default-export */
